import * as React from "react";
import { useState } from "react";
import { observer } from "mobx-react";
import { Button, ButtonGroup, Card, HStack } from "@chakra-ui/react";
import { t } from "i18next";
import { useStores } from "../../../../shared/stores/RootStore";
import { toast } from "../../../../shared/views/CustomToaster";

const PendingCoordChangesControlsBase: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { craNodeStore, craWayStore } = useStores();

  if (craNodeStore.pendingCoordsByNodeId.size === 0) return null;

  const way = craWayStore.getSelected()!;

  const applyPendingCoords = async () => {
    setLoading(true);
    await craNodeStore.applyPendingCoordChanges(way.id);
    toast("success", t(`craway:mapBoxMatching.changesApplied`));
    await craWayStore.refreshCraWay(way.id);
    craNodeStore.clearPendingCoordChanges();
    setLoading(false);
    await craNodeStore.fetchNodes(way.id);
  };

  return (
    <HStack bottom={6} right={2} position="absolute" zIndex={1}>
      <Card.Root>
        <Card.Body p={2}>
          <ButtonGroup attached colorPalette="primary" size="sm">
            <Button
              variant="outline"
              disabled={!craNodeStore.pendingCoordsByNodeId.size}
              loading={loading}
              onClick={() => {
                craNodeStore.clearPendingCoordChanges();
              }}
            >
              {t(`craway:mapBoxMatching.clear`)}
            </Button>
            <Button
              loading={loading}
              onClick={applyPendingCoords}
              disabled={!craNodeStore.pendingCoordsByNodeId.size}
            >
              {t(`craway:mapBoxMatching.apply`)}
            </Button>
          </ButtonGroup>
        </Card.Body>
      </Card.Root>
    </HStack>
  );
};

export const PendingCoordChangesControls = observer(
  PendingCoordChangesControlsBase
);
